<template>
  <CModal :show="show" :centered="true">
    <template #header>
      <h5 class="modal-title">{{ title }}</h5>
    </template>

    <div>
      <p>
        In Loonity we want to empower users to take control of their local food
        distribution network and start collaborating with producers and
        families.
      </p>
      <p>
        Anyone can open a market on Loonity or become a distributor. However,
        the setup has to be conducted by Loonity administrators.
      </p>
      <p>
        Are you interested in opening a market or becoming a distributor? Please
        contact us at <a href="mailto:info@loonity.com">info@loonity.com</a>. We
        would love to hear from you and help you get started.
      </p>
    </div>

    <template #footer>
      <CButton color="primary" variant="outline" @click="close()">
        {{ $t("role.orders.manage.print.closeBtn") }}
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "MarketDistributorModal",

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },

  data() {
    return {};
  },

  watch: {},

  computed: {},

  methods: {
    close() {
      this.$emit("close-modal");
    },
  },
};
</script>
